



















import {Component, Vue, Watch} from "vue-property-decorator";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {CommonStatus} from "@/enums/status";
import {FreightServiceType} from "@/enums/type";
import {FreightServiceAddStore} from "@/modules/freightserviceadds/store";
import debounce from "lodash/debounce";
import {FreightServiceAddParams} from "@/modules/freightserviceadds/params";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";

@Component({
    name: "FreightServiceAddSearch",
    components: {PostOfficeSelector, EnumSelector}
})
export default class extends mixins(CommonMixin) {
    CommonStatus = CommonStatus;
    FreightServiceType = FreightServiceType;
    params = new FreightServiceAddParams();

    @Watch('params', { immediate: false, deep: true })
    onValuesChange(val: any) {
        this.handleChange(val);
    }

    handleChange = debounce(function (val) {
        FreightServiceAddStore.updateFreightServiceAddParams(val);
        FreightServiceAddStore.listFreightServiceAdd({ ...val, page: 1 })
    }, 500);
}
